<div class="card" >
  <ul ngbNav #nav="ngbNav" [activeId]="'richieste'" class="nav-tabs">
    <li ngbNavItem="proveAcquisto" >
      <a ngbNavLink> {{'Matricole'}} </a>
      <ng-template ngbNavContent>
        <app-lista-prova-acquisto></app-lista-prova-acquisto>
      </ng-template>
    </li>
    <li ngbNavItem="richieste" >
      <a ngbNavLink> {{'Richieste'}} </a>
      <ng-template ngbNavContent>
        <app-list [filtro]="filter" >
        </app-list>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
